import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  NbButtonGroupModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbDialogModule,
  NbIconModule,
  NbInputModule,
  NbListModule,
  NbSelectModule,
  NbSpinnerModule,
  NbToggleModule,
  NbTooltipModule
} from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

import { CvGenerateDialogComponent } from './cv-generate-dialog/cv-generate-dialog.component';
import { CvGeneratePanelComponent } from './cv-generate-panel/cv-generate-panel.component';
import { CvDocumentsHubDialogComponent } from './cv-documents-hub/cv-documents-hub-dialog.component';
import { TailorChatComponent } from './cv-tailor/tailor-chat.component';
import { TailorIntakeComponent } from './cv-tailor/tailor-intake.component';
import { ExperiencesPanelComponent } from './cv-tailor/experiences-panel.component';
import { SectionItemsPanelComponent } from './cv-tailor/section-items-panel.component';
import { EducationPanelComponent } from './cv-tailor/education-panel.component';
import { FieldEditorComponent } from './cv-tailor/field-editor.component';
import { PeriodEditorComponent } from './cv-tailor/period-editor.component';
// CvListComponent is declared in AppModule (alongside DualAxisComponent it
// depends on) rather than here. Other CV components stay in CvModule.
import { CvThemeAdminComponent } from './cv-theme-admin/cv-theme-admin.component';
import { StudioComponent } from './studio/studio.component';
import { StudioRailComponent } from './studio/studio-rail/studio-rail.component';
import { StudioPaneBuiltinComponent } from './studio/studio-pane-builtin/studio-pane-builtin.component';
import { StudioPaneCustomComponent } from './studio/studio-pane-custom/studio-pane-custom.component';
import { StudioPaneThemeComponent } from './studio/studio-pane-theme/studio-pane-theme.component';
import { StudioPaneHouseComponent } from './studio/studio-pane-house/studio-pane-house.component';
import { StudioPaneUploadComponent } from './studio/studio-pane-upload/studio-pane-upload.component';
import { CvService } from './cv.service';
import { PagerModule } from '../pager/pager.module';
import { ControlsModule } from '../controls/controls.module';

/**
 * Feature module for the CV generator surface.
 *
 * CvService is `providedIn: 'root'` so it is not listed here. The module
 * declares and exports the components so they can be consumed from the main
 * app module or routed feature modules that import CvModule.
 */
@NgModule({
  declarations: [
    CvGenerateDialogComponent,
    CvGeneratePanelComponent,
    CvDocumentsHubDialogComponent,
    TailorChatComponent,
    TailorIntakeComponent,
    ExperiencesPanelComponent,
    SectionItemsPanelComponent,
    EducationPanelComponent,
    FieldEditorComponent,
    PeriodEditorComponent,
    CvThemeAdminComponent,
    StudioComponent,
    StudioRailComponent,
    StudioPaneBuiltinComponent,
    StudioPaneCustomComponent,
    StudioPaneThemeComponent,
    StudioPaneHouseComponent,
    StudioPaneUploadComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NbCardModule,
    NbButtonModule,
    NbButtonGroupModule,
    NbIconModule,
    NbInputModule,
    NbSelectModule,
    NbCheckboxModule,
    NbSpinnerModule,
    NbListModule,
    NbToggleModule,
    NbTooltipModule,
    NbDialogModule.forChild(),
    TranslateModule.forChild(),
    PagerModule,
    ControlsModule,
    DragDropModule
  ],
  exports: [
    CvGenerateDialogComponent,
    CvGeneratePanelComponent,
    CvDocumentsHubDialogComponent,
    TailorChatComponent,
    TailorIntakeComponent,
    ExperiencesPanelComponent,
    SectionItemsPanelComponent,
    EducationPanelComponent,
    FieldEditorComponent,
    PeriodEditorComponent,
    CvThemeAdminComponent,
    StudioComponent,
    StudioRailComponent,
    StudioPaneBuiltinComponent,
    StudioPaneCustomComponent,
    StudioPaneThemeComponent,
    StudioPaneHouseComponent,
    StudioPaneUploadComponent
  ]
})
export class CvModule {}
